import { Injectable, inject } from '@angular/core';
import { PaymentsCommonService } from '../../../../services/payments/payments-common.service';
import { Payment } from '../../domain/model/payment.model';
import { TicketEvent } from '../../../ticket-events/interface/ticket-event.model';
import { Ticket } from '../../../ticket/domain/model/ticket.model';
import { IPaymentDetails } from '../../../../interfaces/payment.interface';
import { PaymentContext } from '../../domain/value-objects/payment-context.model';

export interface PaymentCompletionData {
  context: PaymentContext;
  payment: Payment;
  paymentDetails: IPaymentDetails;
  ticket: Ticket | null;
}


@Injectable({ providedIn: 'root' })
export class PaymentEventsService {
  private readonly paymentsCommon = inject(PaymentsCommonService);

  notifyPaymentCompletion(data: PaymentCompletionData): void {
    if (data.context.ticketEvent) {
      this.paymentsCommon.updateTicketEvent(data.context.ticketEvent as TicketEvent, data.payment);
    }

    this.paymentsCommon.sendPayManualAccountAmountEvent({
      payment: data.payment,
      ticket: data.ticket,
      currentAudit: data.context.audit,
      currentAccount: data.context.account,
      currentWorker: data.context.worker,
      paymentToSend: data.paymentDetails,
    });
  }
}
